export default __webpack_public_path__ + "static/media/759.741390b0.png";